/**
 * Decode a geotile key (zoom/x/y) to its geographic bounds and center.
 *
 * @param {string} tileKey - The geotile key in "zoom/x/y" format
 * @returns {{ bounds: [[number, number], [number, number]], center: [number, number] } | null}
 */
export function decodeGeotile(tileKey) {
  const parts = tileKey.split('/');
  if (parts.length !== 3) return null;

  const [zoom, x, y] = parts.map(Number);
  const n = Math.pow(2, zoom);

  const lngMin = (x / n) * 360 - 180;
  const lngMax = ((x + 1) / n) * 360 - 180;

  const latMaxRad = Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n)));
  const latMinRad = Math.atan(Math.sinh(Math.PI * (1 - (2 * (y + 1)) / n)));
  const latMax = (latMaxRad * 180) / Math.PI;
  const latMin = (latMinRad * 180) / Math.PI;

  return {
    bounds: [
      [latMin, lngMin],
      [latMax, lngMax],
    ],
    center: [(latMin + latMax) / 2, (lngMin + lngMax) / 2],
  };
}
